<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import ActionCard from 'dashboard/components-next/aivoice/ActionCard.vue';

const emit = defineEmits(['click']);

const onClick = () => {
  emit('click');
};

// Sample actions for background display
const sampleActions = [
  {
    id: 1,
    name: 'check_order_status',
    title: 'Check Order Status',
    description:
      'Retrieve the current status of a customer order by order ID. Returns shipping info and estimated delivery.',
    apiSpec: {
      method: 'GET',
      url: 'https://api.example.com/orders',
      auth: { type: 'bearer' },
    },
    enabled: true,
    voiceAgents: [],
    createdAt: Date.now() - 86400000,
  },
  {
    id: 2,
    name: 'create_support_ticket',
    title: 'Create Support Ticket',
    description:
      'Create a new support ticket in the helpdesk system with customer issue details and priority level.',
    apiSpec: {
      method: 'POST',
      url: 'https://api.example.com/tickets',
      auth: { type: 'api_key' },
    },
    enabled: true,
    voiceAgents: [],
    createdAt: Date.now() - 172800000,
  },
  {
    id: 3,
    name: 'send_notification',
    title: 'Send Notification',
    description:
      'Send SMS or email notifications to customers with order updates, appointment reminders, or alerts.',
    apiSpec: {
      method: 'POST',
      url: 'https://api.example.com/notify',
      auth: { type: 'bearer' },
    },
    enabled: true,
    voiceAgents: [],
    createdAt: Date.now() - 259200000,
  },
  {
    id: 4,
    name: 'get_customer_info',
    title: 'Get Customer Information',
    description:
      'Fetch customer profile data including contact details, preferences, and order history from CRM.',
    apiSpec: {
      method: 'GET',
      url: 'https://api.example.com/customers',
      auth: { type: 'basic' },
    },
    enabled: true,
    voiceAgents: [],
    createdAt: Date.now() - 345600000,
  },
  {
    id: 5,
    name: 'schedule_appointment',
    title: 'Schedule Appointment',
    description:
      'Book appointments in the calendar system. Check availability and send confirmation to customer.',
    apiSpec: {
      method: 'POST',
      url: 'https://api.example.com/appointments',
      auth: { type: 'bearer' },
    },
    enabled: true,
    voiceAgents: [],
    createdAt: Date.now() - 432000000,
  },
];
</script>

<template>
  <EmptyStateLayout
    :title="$t('AI_VOICE.ACTIONS.EMPTY_STATE.TITLE')"
    :subtitle="$t('AI_VOICE.ACTIONS.EMPTY_STATE.SUBTITLE')"
    :action-perms="['administrator']"
  >
    <template #empty-state-item>
      <div class="grid grid-cols-1 gap-4 p-px overflow-hidden">
        <ActionCard
          v-for="action in sampleActions"
          :id="action.id"
          :key="`action-${action.id}`"
          :name="action.name"
          :title="action.title"
          :description="action.description"
          :api-spec="action.apiSpec"
          :enabled="action.enabled"
          :voice-agents="action.voiceAgents"
          :created-at="action.createdAt"
        />
      </div>
    </template>
    <template #actions>
      <Button
        :label="$t('AI_VOICE.ACTIONS.ADD_NEW')"
        icon="i-lucide-plus"
        color="blue"
        @click="onClick"
      />
    </template>
  </EmptyStateLayout>
</template>
